import { lazy, Suspense } from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
} from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { WithAuthProvider } from './shared/AuthContext';
import { WithThemeProvider } from './shared/ThemeContext';
import { Profile } from './features/profile/Profile';
import { Tasks } from "./features/tasks/Tasks";
import { NotFoundPage } from "./shared/utils";
import { TaskDetails } from "./features/tasks/TaskDetails";
import { SubmitTask } from "./features/submit";
import { Admin } from "./features/admin/Admin";
import { Playlists } from "./features/playlists/Playlists";
import { Review } from "./features/review/Review";
import { Editor } from "./features/editor";
import { TopBar } from "./shared/components/TopMenu";
import './shared/components/Layout.css';

const Previews = lazy(() => import("./features/previews"));

function App() {
  return (
    <WithThemeProvider>
      <WithAuthProvider>
        <BrowserRouter>
          <div className="app-shell">
            <TopBar />
            <div className="app-body">
              <div className="main">
                <Routes>
                  <Route path="/" element={<Navigate to="/profile" />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/tasks/submit" element={<SubmitTask />} />
                  <Route path="/tasks/:task_id" element={<TaskDetails />} />
                  <Route path="/tasks" element={<Tasks />} />
                  <Route path="/admin" element={<Navigate to="/admin/subjects" replace />} />
                  <Route path="/admin/:tab" element={<Admin />} />
                  <Route path="/playlists" element={<Playlists />} />
                  <Route path="/review" element={<Review />} />
                  <Route path="/editor" element={<Editor />} />
                  <Route
                    path="/previews"
                    element={
                      <Suspense fallback={<Center h="60vh"><Loader /></Center>}>
                        <Previews />
                      </Suspense>
                    }
                  />
                  <Route path="/*" element={<NotFoundPage />} />
                </Routes>
              </div>
            </div>
          </div>
        </BrowserRouter>
      </WithAuthProvider>
    </WithThemeProvider>
  );
}

export default App;